import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=3dc2157e&"
import script from "./TabLink.vue?vue&type=script&lang=ts&"
export * from "./TabLink.vue?vue&type=script&lang=ts&"
import style0 from "./TabLink.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports